import { InputAdornment, type SxProps, TextField, type Theme } from '@mui/material';
import React from 'react';

interface PercentInputProps {
    value: number;
    disabled?: boolean;
    helperText?: string;
    sx?: SxProps<Theme>;
    onChange(val: number): void;
}

/**
 * Modern PercentInput component with MUI styling.
 * @param {PercentInputProps} props - The props for the percent input.
 * @returns {JSX.Element} The rendered PercentInput component.
 */
export default function PercentInput(props: PercentInputProps) {
    return (
        <TextField
            variant="outlined"
            size="small"
            type="number"
            disabled={props.disabled}
            value={props.value?.toString() || ''}
            helperText={props.helperText}
            onChange={(e) => {
                let nr = 0;
                if (e.target.value !== '') {
                    nr = parseFloat(e.target.value);
                }
                if (nr > 100) nr = 100;
                if (nr < 0) nr = 0;
                props.onChange(nr);
            }}
            InputProps={{
                inputProps: {
                    min: 0,
                    max: 100,
                    step: 1,
                },
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
            }}
            sx={{
                width: 'auto',
                minWidth: '120px',
                '& .MuiInputBase-input': {
                    fontSize: '0.875rem',
                },
                '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                },
                ...props.sx,
            }}
        />
    );
}
